module.exports = __webpack_public_path__ + "static/media/nl_headerlogo.a83159f4.png";